<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12 tw-text-muted">
  <environment-selector></environment-selector>
  <!-- SLG Comment: SLG Copywright -->
  <div bitTypography="body2">
    &copy; {{ year }} Bitwarden Inc. , Changes &copy; {{ year }} Sigma Loyalty Group Inc.
  </div>
  <div bitTypography="body2">{{ version }}</div>
</footer>
